import React, { useState } from 'react';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

import {
  Container,
  Header,
  Left,
  Title,
  LoadingIcon,
  Content,
  ImportantHeader,
  TextConfirm,
  Item,
  InfoContainer,
  Button,
  ButtonContainer,
  Box,
  ItemContainer,
  ModalHeader,
} from './styles';
import api from '~/services/api';
import Botijao from '~/assets/images/botijao-p13-branco.svg';
import Answer2 from '~/components/pages/OrderChecklist/Answer/Contents/2';
import Answer3 from '~/components/pages/OrderChecklist/Answer/Contents/3';
import Answer4 from '~/components/pages/OrderChecklist/Answer/Contents/4';
import Answer5 from '~/components/pages/OrderChecklist/Answer/Contents/5';
import Answer6 from '~/components/pages/OrderChecklist/Answer/Contents/6';
import caminhao from '~/assets/images/truck.png';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import { hasNumberInString, replaceNumberInString } from '~/utils/utils';
import OpenChatBot from '~/components/layout/Chatbot';


export default function OrderChecklist({ close }) {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [answerId, setAnswerId] = useState(null);
  const history = useHistory();

  const dispatch = useDispatch();
  const orderStored = useSelector(state => state.orderReducer);
  const items = useSelector(state => state.orderReducer.items);
  const observation = useSelector(state => state.orderReducer.observation);
  const roles = useSelector(state => state.rolesReducer.roles);

  const createOrder = async () => {
    setLoading(true);
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };

    const url = `/residential/order/v1/orders-ga`;
    const contactId = localStorage.getItem('contactIdSf');
    const storeId = localStorage.getItem('storeId');
    const supplyBrancheId = localStorage.getItem('supplyBranchId');
    const date = orderStored.date;
    const products = [];
    items.map(product => {
      products.push({
        code: product.product.code,
        quantity: product.quantity,
      });
      return null;
    });

    let body = {
      storeId,
      supplyBrancheId,
      serviceType:
        orderStored.order.typeOrder === 'Retira' ? 'RETIRA' : 'ENTREGA',
      contactId,
      orderType: 'GAS_ENVASADO',
      deliveryDate: moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      products,
    };

    if (observation !== 'Nenhuma observação' && observation !== '') {
      body['observation'] = observation;
    }

    const parameters = {
      method: 'POST',
      headers: header,
    };

    if (body.deliveryDate === 'Invalid date') {
      toast.error('A data está inválida');
      setLoading(false);
      return;
    }
    await api
      .post(url, body, parameters)
      .then(res => {
        if (res.status === 201) {
          setLoading(false);
          dispatch({ type: 'SET_ERROR_ORDER', errorOrder: false });
          toast.success('Pedido realizado com sucesso');
          setTimeout(() => {
            history.push('/portal');
            dispatch({ type: 'ORDER_DONE' });
          }, 2000);
          dispatch({ type: 'SET_ORDER_TAKE', orderTake: false });
          dispatch({ type: 'ADD_DATE', date: '' });
          dispatch({
            type: 'ACTIVE_ORDER_MODAL',
            activeModal: {
              order: false,
              modal: !orderStored.activeModal.modal,
            },
          });
        } else {
          errorVerification(res);
        }
      })
      .catch(err => {
        errorVerification(err);
      });
  };

  function errorVerification(err) {
    dispatch({ type: 'SET_ERROR_ORDER', errorOrder: true });
    setLoading(false);
    let displayToast = false;

    const errorsForDisplayApi = [
      "Não foi possível efetuar o cancelamento do pedido. Favor entrar em contato com a logística da filial",
      "A data informada ultrapassa o prazo para gerar pedido com antecedência. Prazo: {number} dias",
      "A filial abastecedora não trabalha neste dia da semana",
      "A data informada é um feriado, favor informar um dia útil.",
      "O horário de atendimento da revenda para pedidos nesta data foi excedido.",
      "O horário de atendimento da revenda para pedidos nesta data foi excedido."
    ]
    const errosDefined = {
      "A filial abastecedora não possui um calendário de trabalho cadastrado": "Não é possível criar solicitação de abastecimento. Favor acionar o suporte para efetuar os devidos ajustes em seu cadastro com a Ultragaz.",
      "A quantidade solicitada no pedido excede o volume permitido.Volume total solicitado: {number} kg. Volume total permitido: {number} kg.": "Quantidade acima do permitido"
    }
    const errorDefault = "Não é possível criar solicitação de abastecimento. Favor acionar o suporte para efetuar os devidos ajustes em seu cadastro com a Ultragaz.";

    const message = hasNumberInString(err.response.data.message) ? replaceNumberInString(err.response.data.message, "{number}") : err.response.data.message;

    const displayedErrorMessages = new Set();

    if (err.response.status !== 502) {
      for (const error of errorsForDisplayApi) {
        if (message.includes(error)) {
          if (!displayedErrorMessages.has(message)) {
            displayToast = true;
            displayedErrorMessages.add(message);

            const messagesSplitedDisplay = err.response.data.message.split(';');
            const errorMessage = messagesSplitedDisplay.length > 1 ? messagesSplitedDisplay[0] : err.response.data.message;
            toast.error(errorMessage);
          }
        }
      }

      for (const key in errosDefined) {
        if (message.includes(key)) {
          if (!displayedErrorMessages.has(key)) {
            displayToast = true;
            displayedErrorMessages.add(key);
            toast.error(errosDefined[key]);
          }
        }
      }

      if (!displayToast) {
        toast.error(errorDefault);
      }
    } else {
      toast.error('Ocorreu um erro, tente novamente!');
    }

    setTimeout(() => {
        history.push('criar/pedido');
    }, 2000);
  }

  return (
    <Container className="background" disableScroll={showModal}>
      {verifyRoles(roles, 'PEDIDO_DE_ABASTECIMENTO') ? (
        <>
          <Box disableScroll={showModal}>
            <Header>
              <Left>
                <img src={Botijao} />
                <Title>Pedido de Abastecimento</Title>
              </Left>
            </Header>
            <Content>
              <ImportantHeader>
                <img src={caminhao} />
                <span>Importante</span>
              </ImportantHeader>
              <TextConfirm>Confira condições de carregamento: </TextConfirm>
              <ItemContainer className="mt-3">
                <Item>
                  <img src="./assets/images/icons/ic_check.svg" />
                  <div>
                    <span>Documentação e apresentação do condutor</span>
                    <br />
                    <button
                      onClick={() => {
                        if (window.screen.width < 770) {
                          history.push(`/confirmacao-pedido/info?id=2`);
                        } else {
                          setAnswerId('2');
                          setShowModal(true);
                        }
                      }}
                    >
                      Leia mais
                    </button>
                  </div>
                </Item>
                <Item>
                  <img src="./assets/images/icons/ic_check.svg" />
                  <div>
                    <span>
                      Documentação do veículo e do produto transportado
                    </span>
                    <br />
                    <button
                      onClick={() => {
                        if (window.screen.width < 770) {
                          history.push(`/confirmacao-pedido/info?id=3`);
                        } else {
                          setAnswerId('3');
                          setShowModal(true);
                        }
                      }}
                    >
                      Leia mais
                    </button>
                  </div>
                </Item>
                <Item>
                  <img src="./assets/images/icons/ic_check.svg" />
                  <div>
                    <span>Conjunto de equipamentos para emergência e EPI</span>
                    <br />
                    <button
                      onClick={() => {
                        if (window.screen.width < 770) {
                          history.push(`/confirmacao-pedido/info?id=4`);
                        } else {
                          setAnswerId('4');
                          setShowModal(true);
                        }
                      }}
                    >
                      Leia mais
                    </button>
                  </div>
                </Item>
                <Item>
                  <img src="./assets/images/icons/ic_check.svg" />
                  <div>
                    <span>
                      Sinalização do veículo (Identificação de unidades de
                      transporte)
                    </span>
                    <br />
                    <button
                      onClick={() => {
                        if (window.screen.width < 770) {
                          history.push(`/confirmacao-pedido/info?id=5`);
                        } else {
                          setAnswerId('5');
                          setShowModal(true);
                        }
                      }}
                    >
                      Leia mais
                    </button>
                  </div>
                </Item>
                <Item>
                  <img src="./assets/images/icons/ic_check.svg" />
                  <div>
                    <span>
                      Estado de conservação do veículo e equipamentos
                      obrigatórios
                    </span>
                    <br />
                    <button
                      onClick={() => {
                        if (window.screen.width < 770) {
                          history.push(`/confirmacao-pedido/info?id=6`);
                        } else {
                          setAnswerId('6');
                          setShowModal(true);
                        }
                      }}
                    >
                      Leia mais
                    </button>
                  </div>
                </Item>
                <Item>
                  <img src="./assets/images/icons/ic_check.svg" />
                  <div>
                    <span>
                      Necessário apresentar a nota fiscal
                      impressa na retirada do seu pedido
                    </span>
                    <br />
                  </div>
                </Item>
              </ItemContainer>
              <InfoContainer>
                <i class="fa fa-exclamation-circle" aria-hidden="true" />
                <span>
                  O não atendimento a qualquer item deste check-list impede a
                  liberação do veículo para carregamento e transporte de
                  produtos perigosos.
                </span>
              </InfoContainer>
              <ButtonContainer>
                {loading ? (
                  <Button>
                    <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                  </Button>
                ) : (
                  <Button onClick={() => createOrder()}>OK, Entendi</Button>
                )}
              </ButtonContainer>
            </Content>
          </Box>
          <Modal
            animation={true}
            show={showModal}
            size="lg"
            centered
            onHide={() => setShowModal(false)}
          >
            <Modal.Body>
              <ModalHeader>
                <i
                  class="fa fa-times"
                  aria-hidden="true"
                  onClick={() => setShowModal(false)}
                />
              </ModalHeader>
              {answerId === '2' ? <Answer2 /> : null}
              {answerId === '3' ? <Answer3 /> : null}
              {answerId === '4' ? <Answer4 /> : null}
              {answerId === '5' ? <Answer5 /> : null}
              {answerId === '6' ? <Answer6 /> : null}
            </Modal.Body>
          </Modal>
        </>
      ) : (
        <Redirect to="/portal" />
      )}
      <OpenChatBot />
    </Container>
  );
}
